import React, { useState } from 'react';
import { TextField, Button, Grid } from '@material-ui/core';
import Loader from 'react-loader-spinner';
import { FileUploader } from 'shared/FileUploader/FileUploader';
import { MainTemplate } from 'shared/MainTemplate/MainTemplate';
import handleNotification from 'helpers/handleNotification';
import { ITaxonomy } from 'api/services/taxonomies/types';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import { taxonomyServices } from 'api/services';
import getImageByImageSize from 'helpers/getImageByImageSize';
import { IFile } from 'api/services/file/types';
import { useHistory } from 'react-router';

import './CreateTaxonomyPage.sass';

export const CreateTaxonomyPage: React.FC = () => {
	const [name, setName] = useState('');
	const [title, setTitle] = useState('');
	const [file, setFile] = useState<IFile>();
	const [loading, setLoading] = useState(false);
	const [hasError, setHasError] = useState(false);
	const history = useHistory();

	const createTaxonomy = async (e: React.FormEvent) => {
		e.preventDefault();
		if (!name.trim() || !title.trim()) {
			setHasError(true);
			handleNotification('Заполните поля');
			return;
		}
		if (!file) {
			setHasError(true);
			handleNotification('Выберите изображение');
			return;
		}
		setLoading(true);
		const data: ITaxonomy = {
			name,
			title,
			fileId: file.id,
		};

		try {
			await taxonomyServices.createTaxonomy(data);
			handleNotification('Таксономия сохранена', 'success');
			history.push('/taxonomies');
		} catch (e: any) {
			handleNotification(
				e?.response?.data?.message || 'Ошибка попробуйте позже',
			);
			setLoading(false);
		}
	};

	const selectFile = (file: IFile) => {
		setFile(file);
	};

	return (
		<MainTemplate title='Создать таксономию' hideBtn>
			<form onSubmit={createTaxonomy}>
				<TextField
					variant='outlined'
					label='Заголовок'
					required
					autoFocus
					className='form-field'
					value={title}
					error={hasError && !title.trim()}
					onChange={(e) => setTitle(e.target.value)}
				/>
				<TextField
					variant='outlined'
					label='Название'
					className='form-field'
					value={name}
					required
					error={hasError && !name.trim()}
					onChange={(e) => setName(e.target.value)}
				/>
				{file && (
					<div className='page-form__file'>
						<img
							className='page-form__file-icon'
							src={getImageByImageSize({ file, imageSize: '100x100' })}
						/>
						<div className='page-form__file-delete'>
							<DeleteForeverIcon
								color='secondary'
								onClick={() => setFile(undefined)}
							/>
						</div>
					</div>
				)}
				<Grid
					container
					justifyContent='space-between'
					className='page-form__actions'>
					<FileUploader
						selectFile={selectFile}
						width={40}
						height={40}
						text={file ? 'Выбрать другую иконку' : 'Выбрать иконку'}
					/>
					<Button
						className='action-button'
						size='large'
						color='primary'
						type='submit'
						variant='contained'
						disabled={loading}>
						{loading ? (
							<Loader height={10} type='ThreeDots' color='#fff' />
						) : (
							'Сохранить'
						)}
					</Button>
				</Grid>
			</form>
		</MainTemplate>
	);
};
